
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#FFE86C"}}),_c('path',{attrs:{"d":"M3.675 11.2l1.75 1.68c4.349-4.175 11.401-4.175 15.75 0l1.75-1.68c-5.311-5.099-13.93-5.099-19.25 0zm7 6.72l2.625 2.52 2.625-2.52c-1.444-1.394-3.798-1.394-5.25 0zm-3.5-3.36l1.75 1.68c2.415-2.318 6.335-2.318 8.75 0l1.75-1.68c-3.377-3.242-8.864-3.242-12.25 0z","fill":"#005149"}})])
          )
        }
      }
    